function isIphone() {
    const ua = navigator.userAgent;

    // Check if the device is an iPhone
    const isIphone = /iPhone/.test(ua);

    // Check if the browser is Safari (but not Chrome or other WebKit browsers)
    const isSafari = /^((?!chrome|android).)*safari/i.test(ua);

    return isIphone && isSafari;
}

export default isIphone;
